import { Player } from './core/Player';
import type { StreamForgeOptions } from './types';

export class StreamForge {
  private player: Player;

  constructor(options: StreamForgeOptions) {
    this.player = new Player(options);
  }

  static init(options: StreamForgeOptions) {
    return new StreamForge(options);
  }

  public getPlayer() { return this.player; }
}

// Global exposure for iife
if (typeof window !== 'undefined') {
  (window as any).StreamForge = StreamForge;
  (window as any).StreamForgePlayer = {
    name: "StreamForge",
    version: "1.0.0",
    player: true
  };
}
